import { render } from "./EvidenceTable.vue?vue&type=template&id=4a1da027"
import script from "./EvidenceTable.vue?vue&type=script&lang=js"
export * from "./EvidenceTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__